import { Locale, LocalizedString } from '@synergy/models';
import { PropsWithChildren, createContext, useContext } from 'react';
import { decodeHtml } from '@synergy/utils';
import { getLocalizedString } from '@synergy/utils';

class LocalizedContextData {
    constructor(public locales: Locale[]) {}

    public getLocalizedString = (value?: LocalizedString): string =>
        decodeHtml(getLocalizedString(this.locales, value)) ?? '';
}

interface LocalizedContextProps {
    locales: Locale[];
}

export const LocalizedContext = createContext<LocalizedContextData>(new LocalizedContextData([]));

export const useLocalizedContext = () => useContext(LocalizedContext);

export const LocalizedProvider = (props: PropsWithChildren<LocalizedContextProps>) => {
    return (
        <LocalizedContext.Provider value={new LocalizedContextData(props.locales)}>
            {props.children}
        </LocalizedContext.Provider>
    );
};
